const getters = {
  getMonitorUserList(state) {
    return state.users;
  },
};

export default getters;
